import { render, staticRenderFns } from "./channelConfiguration.vue?vue&type=template&id=23e26d68&scoped=true&"
import script from "./channelConfiguration.vue?vue&type=script&lang=js&"
export * from "./channelConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./channelConfiguration.vue?vue&type=style&index=0&id=23e26d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e26d68",
  null
  
)

export default component.exports